/**
 * ReportViewer 公共组件常量定义
 */
import React from 'react';
import { Bubble } from 'tea-component';
import classNames from 'classnames';
import { TReportStepType } from './types';
import copySuccessIcon from '@/pages/aigc/assets/svg/agent-copy-success.svg';

/** 报告步骤类型枚举值 */
export const REPORT_STEP_TYPE = {
  FRAMEWORK: 'framework' as TReportStepType,
  REPORT: 'report' as TReportStepType,
};

/** 报告操作类型枚举 */
export enum EReportActions {
  ReportReset = 'report_reset',
  ReportCopy = 'report_copy',
  ReportExport = 'report_export',
  ReportSave = 'report_save',
  ImplementReset = 'implement_reset',
  ImplementGenerate = 'implement_generate',
}

/** 导出文件类型枚举 */
export enum EExportFileType {
  PDF = 'pdf',
  TXT = 'txt',
  Word = 'word',
}

/** 步骤页签配置 */
export const REPORT_STEP_TABS_CONFIG = [
  {
    label: '分析思路',
    labelEn: 'Framework',
    value: REPORT_STEP_TYPE.FRAMEWORK,
  },
  {
    label: '分析报告',
    labelEn: 'Report',
    value: REPORT_STEP_TYPE.REPORT,
  },
];

/** 导出文件类型配置 */
export const EXPORT_FILE_TYPE_CONFIG = [
  { label: 'PDF', value: EExportFileType.PDF, labelEn: 'PDF' },
  { label: 'TXT', value: EExportFileType.TXT, labelEn: 'TXT' },
  { label: 'Word', value: EExportFileType.Word, labelEn: 'Word' },
];

/** 获取工具栏操作列表 */
export const getReportToolbarActions = (
  isEn: boolean,
  streamingState: string,
  copyStatus = false,
  icons: {
    refreshIcon: string;
    copyIcon: string;
    exportIcon: string;
    saveIcon: string;
  }
) => [
  {
    label: (
      <div className="dba-report-viewer-toolbar-action">
        <img src={icons.refreshIcon} alt="" />
        {isEn ? 'Reset' : '重置'}
      </div>
    ),
    value: REPORT_STEP_TYPE.REPORT,
    key: EReportActions.ReportReset,
  },
  {
    label: (
      <Bubble
        visible={copyStatus}
        overlayClassName="dba-report-copy-bubble-overlay"
        content={
          <div className="dba-feedback-operation-copy-contenet">
            <img src={copySuccessIcon} alt="" style={{ width: 16, height: 16, marginRight: 5 }} /> {isEn ? 'Copy succeeded' : '复制成功'}
          </div>
        }
      >
        <div className="dba-report-viewer-toolbar-action">
          <img src={icons.copyIcon} alt="" />
          {isEn ? 'Copy' : '复制'}
        </div>
      </Bubble>
    ),
    value: REPORT_STEP_TYPE.REPORT,
    key: EReportActions.ReportCopy,
  },
  {
    label: (
      <div className="dba-report-viewer-toolbar-action">
        <img src={icons.exportIcon} alt="" />
        {isEn ? 'Export' : '导出'}
      </div>
    ),
    value: REPORT_STEP_TYPE.REPORT,
    key: EReportActions.ReportExport,
  },
  {
    label: (
      <div className="dba-report-viewer-toolbar-action dba-report-viewer-toolbar-action--primary">
        <img src={icons.saveIcon} alt="" />
        {isEn ? 'Save' : '保存'}
      </div>
    ),
    value: REPORT_STEP_TYPE.REPORT,
    key: EReportActions.ReportSave,
  },
  {
    label: (
      <div className="dba-report-viewer-toolbar-action">
        <img src={icons.refreshIcon} alt="" />
        {isEn ? 'Reset' : '重置'}
      </div>
    ),
    value: REPORT_STEP_TYPE.FRAMEWORK,
    key: EReportActions.ImplementReset,
  },
  {
    label: (
      <div
        className={classNames(
          'dba-report-viewer-toolbar-action dba-report-viewer-toolbar-action--primary',
          {
            'dba-report-viewer-toolbar-action--disabled':
              streamingState && streamingState !== 'complete',
          }
        )}
      >
        {isEn ? 'Generate Report' : '生成分析报告'}
      </div>
    ),
    value: REPORT_STEP_TYPE.FRAMEWORK,
    key: EReportActions.ImplementGenerate,
  },
];
